import { render, staticRenderFns } from "./CardAdminInfo.vue?vue&type=template&id=7fc67064&scoped=true&"
import script from "./CardAdminInfo.vue?vue&type=script&lang=js&"
export * from "./CardAdminInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardAdminInfo.vue?vue&type=style&index=0&id=7fc67064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc67064",
  null
  
)

export default component.exports